import { render, staticRenderFns } from "./PromotionTimeLine.vue?vue&type=template&id=46331121"
import script from "./PromotionTimeLine.vue?vue&type=script&lang=js"
export * from "./PromotionTimeLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports